<ng-container>
  <div class="row">
    @if (showToggle()) {
      <div class="toggle" (click)="expanded.set(!expanded())">☰</div>
    }
    @if (store.view.type()) {
      <div class="wide">
        @if (expanded() && store.view.showRemotesCheckbox()) {
          <app-search />
          @if (admin.getPlugin('+plugin/origin')) {
            <div class="show-remotes">
              <input id="show-remotes" #sr type="checkbox" [checked]="store.view.showRemotes()" (input)="showRemotes = sr.checked">
              <label for="show-remotes" i18n>show remotes</label>
            </div>
          }
        } @else {
          <app-search class="centered" />
        }
      </div>
    }
  </div>
  @if (store.view.type()) {
    @if (tag() && (store.view.tag() || store.view.template())) {
      @if (!user()) {
        <app-query [query]="tag()" class="breadcrumbs" />
      } @else {
        <app-nav class="center" [url]="'tag:/' + tag()" />
        <div class="tag-select row center">
          <div class="submit-button"
               routerLinkActive="toggled"
               [routerLink]="['/tag', inbox()]"
               tabindex="0">
            <span i18n-title title="Inbox" i18n>📥️</span> <label i18n>Inbox</label>
          </div>
          <div class="submit-button"
               routerLinkActive="toggled"
               [routerLink]="['/tag', outbox()]"
               tabindex="0">
            <span i18n-title title="Outbox" i18n>📤️</span> <label i18n>Outbox</label>
          </div>
        </div>
      }
    }
  }
  @if (expanded()) {
    @if (store.view.type()) {
      <div class="row mini-col reverse">
        <app-filter [type]="store.view.type()!" [activeExts]="activeExts()" />
        <app-sort [type]="store.view.type()!" />
      </div>
    }
    <app-debug />
    @if (store.view.type()) {
      <app-bulk [type]="store.view.type()!"
                [viewExt]="ext()"
                [activeExts]="activeExts()" />
    }
  }
  <span class="button-bar">
    @if (videoChat()) {
      <app-chat-video [url]="store.view.ref()?.url || 'tag:/chat'" />
    }
    @if (!dm() && !user() && canAddTag() && !plugin()?.config?.reply && store.account.user && (store.view.type() === 'ref' || store.view.current() === 'ref/summary')) {
      @if (plugin()?.config?.submitText || rootConfig()?.submitText) {
        <div class="submit-button" routerLink="/submit/text" tabindex="0"
             [queryParams]="{ tag: addTags(), location: location() }">
        <span i18n-title title="Submit" i18n>📝️</span> <label i18n>Submit
        &nbsp;
        &nbsp;
          {{ plugin()?.name || '' }}</label>
      </div>
      } @else if (plugin()?.config?.submit && plugin()?.config?.genId) {
        <div class="submit-button" routerLink="/submit/web" tabindex="0"
             [queryParams]="{ tag: addTags(), url: genUrl, location: location() }">
          <span i18n-title title="Submit" i18n>📝️</span> <label i18n>Submit
          &nbsp;
          &nbsp;
          {{ plugin()!.config!.submit }}</label>
        </div>
      } @else {
        <div class="submit-button" routerLink="/submit" tabindex="0"
             [queryParams]="{ tag: addTags(), location: location() }">
          <span i18n-title title="Submit" i18n>📝️</span> <label i18n>Submit
          &nbsp;
          &nbsp;
          {{ plugin()?.config?.submit || '' }}</label>
        </div>
      }
    }
    @if (notes() && (home() || store.account.tag() === tag() || addTags().includes('notes'))) {
      <div class="submit-button" routerLink="/submit/dm"  tabindex="0"
           [queryParams]="{ to: null }">
        <span i18n-title title="Notes" i18n>✍️</span> <label i18n>Notes</label>
      </div>
    }
    @if (store.account.tag() !== tag() && messages()) {
      @if (dms().length) {
        <div class="submit-button" routerLink="/submit/dm"  tabindex="0"
             [queryParams]="{ to: dms(), tag: null }">
          <span i18n-title title="Direct Message" i18n>✉️</span> <label i18n>Message</label>
        </div>
      } @else if (mailPlugin()) {
        <div class="submit-button" routerLink="/submit/dm"  tabindex="0"
             [queryParams]="{ to: tag(), tag: mailPlugin()!.tag }">
          <span i18n-title title="Direct Message" i18n>✉️</span> <label i18n>Message
          &nbsp;
          &nbsp;
          {{ mailPlugin()!.config?.submit || '' }}</label>
        </div>
      } @else if (dm() || modmail() || user()) {
        <div class="submit-button" routerLink="/submit/dm"  tabindex="0"
             [queryParams]="{ to: tag(), tag: null }">
          <span i18n-title title="Direct Message" i18n>✉️</span> <label i18n>Message</label>
        </div>
      }
    }
    @if (store.account.mod && store.view.current() === 'settings/user') {
      <div class="submit-button" routerLink="/user" tabindex="0">
        <span i18n-title title="Create User" i18n>🧑️</span> <label i18n>Create Permissions</label>
      </div>
    }
    @if (store.account.admin && (store.view.current() === 'settings/plugin' || store.view.current() === 'settings/template')) {
      <div class="submit-button upload-plugin-button"
           (click)="uploadPluginFile.click()"
           (keydown.enter)="uploadPluginFile.click()"
           tabindex="0">
        <span i18n-title title="Upload Plugin" i18n>🧰️</span> <label i18n>Upload Dev Plugin</label>
      </div>
      <input #uploadPluginFile
             type="file"
             class="upload-plugin"
             (change)="uploadPlugins(uploadPluginFile.files!); uploadPluginFile.value = ''">
      <div class="submit-button upload-template-button"
           (click)="uploadTemplateFile.click()"
           (keydown.enter)="uploadTemplateFile.click()"
           tabindex="0">
        <span i18n-title title="Upload Template" i18n>🎨️</span> <label i18n>Upload Dev Template</label>
      </div>
      <input #uploadTemplateFile
             type="file"
             class="upload-template"
             (change)="uploadTemplates(uploadTemplateFile.files!); uploadTemplateFile.value = ''">
      @for (e of uploadErrors(); track e) {
        <div class="error">{{ e }}</div>
      }
    }
    @if (writeAccess() && user() && store.view.current() === 'tag') {
      <div class="submit-button" [routerLink]="['/user', tag()]" tabindex="0">
        <span i18n-title title="Edit User" i18n>🧑️</span> <label i18n>Edit Permissions</label>
      </div>
    }
    @if (homeWriteAccess()) {
      <div class="submit-button" [routerLink]="['/ext', 'config/home']" tabindex="0">
        <span i18n-title title="Edit Home Page" i18n>🏡️</span> <label i18n>Home Page</label>
      </div>
    } @else if (store.view.type() === 'ext') {
      @if (writeAccess()) {
        <div class="submit-button" [routerLink]="['/ext', store.view.template()]" tabindex="0">
          <span i18n-title title="Extend Tag" i18n>🎨️</span> <label i18n>Extend Tag
          &nbsp;
          &nbsp;
          {{ template()?.name || '' }}</label>
        </div>
      } @else if (!store.view.template()) {
        <div class="submit-button" [routerLink]="['/ext']" tabindex="0">
          <span i18n-title title="Extend Tag" i18n>🎨️</span> <label i18n>Extend Tag</label>
        </div>
      }
    } @else if (local() && writeAccess() && store.view.noQuery()) {
      <div class="submit-button" [routerLink]="['/ext', tag()]" tabindex="0">
        <span i18n-title title="Edit Tag" i18n>🎨️</span> <label i18n>Edit Tag</label>
      </div>
    } @else if (!local() && store.account.user && existing() && store.view.noQuery()) {
      <div class="submit-button" [routerLink]="['/tags', tag()]" [queryParams]="{ showRemotes: true }" tabindex="0">
        <span i18n-title title="Edit Tag" i18n>🎨️</span> <label i18n>Copy Tag</label>
      </div>
    }
  </span>
  @if (home()) {
    <div class="hide tag-header">
      @if (store.view.forYou()) {
        <h3><a [routerLink]="['/home']" [queryParams]="{ forYou: true }" i18n>For You</a></h3>
        @if (!store.account.userSubs().length) {
          <p i18n>Follow other users to see their subscriptions alongside yours here.</p>
        }
      } @else {
        <h3><a [routerLink]="['/home']" i18n>Home</a></h3>
      }
    </div>
  }
  @if (!home() && store.view.tag()) {
    <div class="hide tag-header">
      @if (store.view.current() === 'tag') {
        <h3>{{ ext()?.name || tag() }}</h3>
      }
      @if (store.account.signedIn() && tag() && tag() !== '@*' && tag() != '*' && admin.getTemplate('user')) {
        <div class="row center">
          @if (inBookmarks()) {
            <button type="button"
                    class="bookmark"
                    i18n-title title="Remove from top bar"
                    [disabled]="savingBookmark()"
                    (click)="removeBookmark()" i18n>&ndash; bookmark</button>
          } @else {
            <button type="button"
                    (click)="addBookmark()"
                    i18n-title title="Add to top bar"
                    [disabled]="savingBookmark()"
                    class="bookmark" i18n>+ bookmark</button>
          }
          @if (admin.home()) {
            @if (user()) {
              @if (inSubs()) {
                <button type="button"
                        class="subscribe"
                        i18n-title title="Remove from home screen"
                        [disabled]="savingSub()"
                        (click)="unsubscribe()" i18n>&ndash; unfollow</button>
              } @else {
                <button type="button"
                        (click)="subscribe()"
                        i18n-title title="Add to home screen"
                        [disabled]="savingSub()"
                        class="subscribe" i18n>+ follow</button>
              }
            } @else {
              @if (inSubs()) {
                <button type="button"
                        class="subscribe"
                        i18n-title title="Remove from home screen"
                        [disabled]="savingSub()"
                        (click)="unsubscribe()" i18n>&ndash; unsubscribe</button>
              } @else {
                <button type="button"
                        (click)="subscribe()"
                        i18n-title title="Add to home screen"
                        [disabled]="savingSub()"
                        class="subscribe" i18n>+ subscribe</button>
              }
            }
          }
          @if (inAlarms()) {
            <button type="button"
                    class="alarm"
                    i18n-title title="Remove alarm"
                    [disabled]="savingAlarm()"
                    (click)="removeAlarm()" i18n>🔇</button>
          } @else {
            <button type="button"
                    (click)="addAlarm()"
                    i18n-title title="Add alarm"
                    [disabled]="savingAlarm()"
                    class="alarm" i18n>🔔</button>
          }
        </div>
      }
    </div>
  }
  @if (ui() && ext()) {
    <app-md class="hide ui"
            [disableSanitizer]="true"
            [origin]="ext()!.origin || ''"
            [text]="uiMarkdown()" />
  }
  @if (root()) {
    <div class="hide template-root">
      @if (ext()?.config?.sidebar) {
        <app-md [origin]="ext()?.origin || ''" [text]="ext()!.config!.sidebar" />
      }
    </div>
  }
  @if (!home() && expanded()) {
    @for (res of queryExts(); track res.x.tag) {
      <h5>{{ res.x.name || res.x.tag}} Tags:</h5>
      @for (x of res.children; track x.tag + x.origin) {
        <app-ext [ext]="x" [useEditPage]="true" />
      }
      @if (res.more) {
        <a [routerLink]="['/tags', res.x.tag]"
           queryParamsHandling="merge"
           class="load-more no-select" i18n>
          load more
        </a>
      }
    }
    @if (chat()) {
      <app-chat query="chat" [responseOf]="store.view.ref()" />
    } @else if (store.view.ref() && admin.getPlugin('plugin/chat')) {
      <a class="fake-link load-more" (click)="startChat()" i18n>chat</a>
    }
  }
</ng-container>
